<template>
  <section class="about-gift-cards">
    <AboutPageHeadline title="GIFT CARD" sub-title="ギフトカード" />
    <p class="about-gift-cards__text">
      シーンに合わせた豊富なギフトカードデザインをご用意しています
    </p>
    <div class="about-gift-cards__contents">
      <div class="about-gift-cards__content">
        <p class="about-gift-cards__sub-head">
          Thank you
        </p>
        <p class="about-gift-cards__head">
          ありがとう
        </p>
        <div class="about-gift-cards__cards">
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/thanks/card.jpg"
              alt="card"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/thanks/2003_kuma_thankyou.png"
              alt="kuma"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/thanks/1910_Thankyou_Thankyou.jpg"
              alt="thankyou"
            />
          </div>
        </div>
      </div>
      <div class="about-gift-cards__content">
        <p class="about-gift-cards__sub-head">
          Good job
        </p>
        <p class="about-gift-cards__head">
          おつかれさま
        </p>
        <div class="about-gift-cards__cards">
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/goodjob/2005_chanpachi_otsukare.jpg"
              alt="card"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/goodjob/PxY_Foryou.jpg"
              alt="kuma"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/goodjob/1912_otsukaresama.jpg"
              alt="thankyou"
            />
          </div>
        </div>
      </div>
      <div class="about-gift-cards__content">
        <p class="about-gift-cards__sub-head">
          Congratulations
        </p>
        <p class="about-gift-cards__head">
          おめでとう
        </p>
        <div class="about-gift-cards__cards">
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/congratulations/Wedding_Pop.jpg"
              alt="card"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/congratulations/2002_congratulations.jpg"
              alt="kuma"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/congratulations/1911_birthday_cake.jpg"
              alt="thankyou"
            />
          </div>
        </div>
      </div>
      <div class="about-gift-cards__content">
        <p class="about-gift-cards__sub-head">
          Season
        </p>
        <p class="about-gift-cards__head">
          季節のあいさつ
        </p>
        <div class="about-gift-cards__cards">
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/season/2009_tosyo.jpg"
              alt="card"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/season/2008_sunflower.jpg"
              alt="kuma"
            />
          </div>
          <div class="about-gift-cards__card">
            <img
              src="../../../../../../images/abouts/cards/season/image.png"
              alt="thankyou"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="about-gift-cards-see-more">
      <a href="/card_designs" class="about-gift-cards-see-more__link">
        <span class="about-gift-cards-see-more__text">{{
          'カードデザイン一覧をみる'
        }}</span>
        <ArrowForwardPrimary class="about-gift-cards-see-more__icon" />
      </a>
    </div>
  </section>
</template>

<script>
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline'
import ArrowForwardPrimary from '../../../atoms/svg_icons/ArrowForwardPrimary'
export default {
  components: { AboutPageHeadline, ArrowForwardPrimary }
}
</script>

<style lang="scss" scoped>
.about-gift-cards {
  padding: 100px 5% 100px;

  @media all and (max-width: $pc-width  - 1) {
    padding: 56px 24px 48px;
  }

  &__text {
    margin: 40px auto 0;
    text-align: left;
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 2;
    letter-spacing: 0.06em;
    color: $black;
    max-width: calc(1440px - (5% * 2));

    @media all and (max-width: $pc-width  - 1) {
      margin-top: 24px;
    }
  }

  &__contents {
    margin: auto;
    display: grid;
    grid-template-columns: repeat(2, 50%);
    max-width: calc(1440px - (5% * 2));

    @media all and (max-width: $base-contents-width - 1) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__content {
    margin: 40px 20px 0 0;
    padding: 24px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
    border-radius: 16px;

    &:nth-of-type(2),
    &:nth-of-type(4) {
      margin: 40px 0 0 20px;
    }

    @media all and (max-width: $pc-width  - 1) {
      margin: 24px 12px 0 0;

      &:nth-of-type(2),
      &:nth-of-type(4) {
        margin: 24px 0 0 12px;
      }
    }

    @media all and (max-width: $base-contents-width - 1) {
      margin: 24px 0 0 0;

      &:nth-of-type(2),
      &:nth-of-type(4) {
        margin: 24px 0 0 0;
      }
    }
  }

  &__sub-head {
    font-size: 1.6rem;
    line-height: 2;
    letter-spacing: 0.06em;
    color: $gray-1;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.4rem;
    }
  }

  &__head {
    margin-top: 8px;
    font-weight: bold;
    font-size: 2.4rem;
    line-height: 2;
    letter-spacing: 0.06em;
    color: $black;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.8rem;
    }
  }

  &__cards {
    margin-top: 24px;
    display: flex;
  }

  &__card {
    margin: 12px;
    width: 33%;
    border-radius: 8px;
    overflow: hidden;
    font-size: 0;

    @media all and (max-width: $pc-width  - 1) {
      margin: 6px;
    }

    img {
      width: 100%;
    }
  }

  &-see-more {
    margin: 24px auto 0;
    padding: 16px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: calc(1440px - (5% * 2));

    @media all and (max-width: $pc-width  - 1) {
      margin: 8px auto 0;
      justify-content: center;
    }

    @media all and (max-width: $base-contents-width - 1) {
      margin: 24px auto 0;
    }

    &__link {
      @extend %hover-common;
      display: flex;
      align-items: center;
    }

    &__text {
      margin-right: 8px;
      color: $primary;
      font-weight: bold;
      font-size: 1.6rem;
      line-height: 2;
      letter-spacing: 0.06em;

      @media all and (max-width: $pc-width  - 1) {
        margin-right: 0;
        font-size: 1.4rem;
      }

      @media all and (max-width: $sp-iphone5-width) {
        font-size: 1.2rem;
      }
    }

    &__icon {
      width: 24px;
    }
  }
}
</style>
